import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { ArrowLeftIcon, Button, Image, Text } from "@sundae/ui-toolkit";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import { useNavigate } from "@tanstack/react-location";
import cx from "classnames";
import ConnectWalletNotice from "../../components/ConnectWalletNotice";
import { CreateProposalForm } from "../../components/Forms";
import LoadingState from "../../components/LoadingState";
import { usePermissions } from "../../hooks";
import { useAppConfig } from "../../hooks/useAppConfig";
const Home = () => {
    const { t } = useI18N();
    const { mainAddress } = useWalletObserver();
    const { canCreate, isLoading } = usePermissions();
    const config = useAppConfig();
    const navigate = useNavigate();
    if (isLoading) {
        return _jsx(LoadingState, {});
    }
    if (mainAddress && !canCreate) {
        return (_jsxs("div", { className: "mb-8 flex w-full flex-col items-center justify-center gap-8", children: [_jsx(Image, { src: config.brand.images.not_enough_tokens, width: 200, height: 200, alt: t("states.success.title") }), _jsxs("div", { className: "flex flex-col items-center gap-2", children: [_jsx(Text, { tag: "h4", size: "4xl", weight: "bold", children: t("not_enough_title", { ns: "voting" }) }), _jsx(Text, { tag: "p", className: "text-center", variant: "muted", children: t("not_enough_proposal", {
                                ns: "voting",
                                brand: config?.brand?.title,
                            }) })] }), _jsx("div", { className: "flex w-full items-center justify-center gap-4", children: _jsxs(Button, { variant: "primary", className: cx("flex items-center justify-center gap-2", config.brand.classes.buttons.all, config.brand.classes.buttons.primary), onClick: () => navigate({
                            to: "/",
                        }), children: [_jsx(ArrowLeftIcon, {}), t("actions.back", { ns: "proposal" })] }) })] }));
    }
    return (_jsx("div", { className: "h-full w-full", children: mainAddress ? _jsx(CreateProposalForm, {}) : _jsx(ConnectWalletNotice, {}) }));
};
export default Home;
//# sourceMappingURL=Create.js.map